export default "__VITE_ASSET__C1CBfK0h__"